import { mapDataSource, RawDataSource } from '~/Api/DataSource';
import Price from '~/utils/Price';

import { CalculationPrice, PriceType } from './CalculationPrice';

interface RawCalculationPriceProduct {
	id: string;
	dataSource: RawDataSource;
}

export interface RawCalculationPrice {
	currency: string;
	value: string;
	fromProducts: RawCalculationPriceProduct[];
	priceType: PriceType;
}

export interface RawFxUpdatePrice {
	value: string;
	currency: string;
}

export interface RawPrgPrbPrice {
	value: string;
	currency: string;
}

export interface RawPriPrice {
	value: string;
	currency: string;
}

export const mapCalculationPrice = (calculationPrice: RawCalculationPrice): CalculationPrice => ({
	price: new Price(calculationPrice.value, calculationPrice.currency),
	fromProducts: calculationPrice.fromProducts.map((product) => ({
		id: product.id,
		dataSource: mapDataSource(product.dataSource),
	})),
	priceType: calculationPrice.priceType,
});
